import { RegionKey } from './menuConfig.ts';

export interface UnlockedItemDef {
  id: string;
  name: string;
  icon: string;
  desc: string;
  costPrice: number;
  sellPrice: number;
}

export interface StallLevelDef {
  level: number;
  title: string;
  cupsRequired: number;
  unlockedItems: UnlockedItemDef[];
  description: string;
}

export interface SurvivalPerkDef {
  id: string;
  day: number;
  name: string;
  icon: string;
  desc: string;
  benefit: string;
}

export const REGIONAL_STALL_LEVELS: Record<RegionKey, StallLevelDef[]> = {
  north: [
    {
      level: 1,
      title: 'Quầy Cóc Khởi Nghiệp',
      cupsRequired: 0,
      unlockedItems: [],
      description: 'Bàn ghế nhựa giản dị, bắt đầu sự nghiệp vỉa hè với trà đá mát lạnh.',
    },
    {
      level: 2,
      title: 'Quán Nước Quen Mặt',
      cupsRequired: 25,
      unlockedItems: [
        {
          id: 'tra_chanh',
          name: 'Trà Chanh Phố Cổ',
          icon: '🍋',
          desc: 'Trà chanh pha sẵn chua ngọt mát lạnh ven hồ',
          costPrice: 4_500,
          sellPrice: 12_000,
        },
        {
          id: 'nuoc_mia',
          name: 'Nước Mía Siêu Sạch',
          icon: '🎋',
          desc: 'Mía ngọt lịm thơm quất ép sẵn ướp lạnh tức thì',
          costPrice: 5_000,
          sellPrice: 10_000,
        },
      ],
      description: 'Khách quen bắt đầu nhớ mặt chủ quán, mở thêm đồ uống giải nhiệt đắt hàng!',
    },
    {
      level: 3,
      title: 'Điểm Hẹn Buôn Chuyện',
      cupsRequired: 60,
      unlockedItems: [
        {
          id: 'huong_duong',
          name: 'Đĩa Hướng Dương',
          icon: '🌻',
          desc: 'Gói hướng dương cắn tí tách, giữ chân khách buôn chuyện',
          costPrice: 8_500,
          sellPrice: 15_000,
        },
        {
          id: 'sau_da',
          name: 'Nước Sấu Đá Chua Ngọt',
          icon: '🍏',
          desc: 'Sấu ngâm gừng Hà Nội chua ngọt giòn sần sật',
          costPrice: 6_500,
          sellPrice: 15_000,
        },
      ],
      description: 'Có đồ cắn lai rai, nhóm bạn rủ nhau ngồi buôn chuyện kín cả góc hè!',
    },
    {
      level: 4,
      title: 'Cà Phê Bệt Có Tiếng',
      cupsRequired: 120,
      unlockedItems: [
        {
          id: 'ca_phe_sua',
          name: 'Cà Phê Sữa Nâu Đá',
          icon: '☕',
          desc: 'Phin đậm đà ngọt béo pha sẵn ủ lạnh',
          costPrice: 8_000,
          sellPrice: 18_000,
        },
        {
          id: 'banh_mi_que',
          name: 'Bánh Mì Que Hải Phòng',
          icon: '🥖',
          desc: 'Pate béo ngậy ớt chí chương giòn tan đóng gói',
          costPrice: 10_500,
          sellPrice: 18_000,
        },
      ],
      description: 'Phục vụ cả đồ ăn sáng và cà phê đậm đà cho dân công sở, doanh thu bứt phá!',
    },
    {
      level: 5,
      title: 'Tụ Điểm Hút Giới Trẻ',
      cupsRequired: 250,
      unlockedItems: [
        {
          id: 'tra_tac_khong_lo',
          name: 'Trà Tắc Khổng Lồ',
          icon: '🍊',
          desc: 'Bình trà tắc chua ngọt đã khát giải nhiệt hè',
          costPrice: 5_000,
          sellPrice: 15_000,
        },
        {
          id: 'nem_chua_ran',
          name: 'Nem Chua Rán Hà Nội',
          icon: '🍢',
          desc: 'Đĩa nem chua rán giòn thơm chấm tương ớt',
          costPrice: 14_000,
          sellPrice: 25_000,
        },
      ],
      description: 'Thanh niên kéo đến nườm nượp, menu ăn vặt hút khách ngồi kín bàn!',
    },
    {
      level: 6,
      title: 'Đặc Sản Vỉa Hè Nổi Tiếng',
      cupsRequired: 500,
      unlockedItems: [
        {
          id: 'ca_phe_trung',
          name: 'Cà Phê Trứng Hà Nội',
          icon: '☕',
          desc: 'Bọt trứng béo ngậy quện cà phê phin sánh mịn',
          costPrice: 12_000,
          sellPrice: 25_000,
        },
        {
          id: 'cacao_dua_dam',
          name: 'Cacao Dừa Dầm Ly Đá',
          icon: '🥥',
          desc: 'Dừa nạo giòn thạch cacao dầm đá mát lạnh',
          costPrice: 11_000,
          sellPrice: 22_000,
        },
      ],
      description: 'Quán có những món đặc sản trứ danh, khách du lịch và reviewer đua nhau tìm đến!',
    },
    {
      level: 7,
      title: 'Đại Bản Doanh Vỉa Hè',
      cupsRequired: 1000,
      unlockedItems: [
        {
          id: 'mi_tom_trung',
          name: 'Mì Ly Ăn Liền Chế Nước',
          icon: '🍜',
          desc: 'Mì ly ăn liền chế nước sôi nhanh gọn cứu đói đêm',
          costPrice: 12_000,
          sellPrice: 22_000,
        },
        {
          id: 'bia_hoi',
          name: 'Bia Hơi Vỉa Hè Thùng Đá',
          icon: '🍺',
          desc: 'Bia tươi ướp thùng đá mát lạnh giữ chân khách nhậu',
          costPrice: 8_000,
          sellPrice: 15_000,
        },
      ],
      description: 'Đầy đủ đồ uống giải khát, đồ nhắm và đồ ăn khuya, phục vụ xuyên ngày đêm!',
    },
    {
      level: 8,
      title: 'Huyền Thoại Vỉa Hè',
      cupsRequired: 2000,
      unlockedItems: [],
      description: 'Vang danh khắp phố phường! Bạn chính là ông trùm vỉa hè độc nhất vô nhị!',
    },
  ],

  central: [
    {
      level: 1,
      title: 'Quầy Cóc Khởi Nghiệp',
      cupsRequired: 0,
      unlockedItems: [],
      description: 'Bàn ghế nhựa giản dị, bắt đầu sự nghiệp vỉa hè miền Trung nắng gió.',
    },
    {
      level: 2,
      title: 'Quán Nước Quen Mặt',
      cupsRequired: 25,
      unlockedItems: [
        {
          id: 'nuoc_mia_thom',
          name: 'Nước Mía Thơm Lá Dứa',
          icon: '🎋',
          desc: 'Mía ép thơm quả dứa ngọt thanh mát ruột',
          costPrice: 5_000,
          sellPrice: 10_000,
        },
        {
          id: 'tra_cung_dinh',
          name: 'Trà Cung Đình Thảo Mộc',
          icon: '👑',
          desc: 'Trà thảo mộc thanh nhiệt đóng chai ướp lạnh tao nhã',
          costPrice: 7_000,
          sellPrice: 15_000,
        },
      ],
      description: 'Khách quen nhớ quán nước mát, nước mía thơm và trà cung đình hút khách!',
    },
    {
      level: 3,
      title: 'Điểm Hẹn Buôn Chuyện',
      cupsRequired: 60,
      unlockedItems: [
        {
          id: 'dau_phong_rang',
          name: 'Đậu Phộng Rang Tỏi Ớt',
          icon: '🥜',
          desc: 'Hũ đậu phộng giòn rụm cay cay vui miệng',
          costPrice: 6_000,
          sellPrice: 12_000,
        },
        {
          id: 'che_hem',
          name: 'Chè Hẻm Cố Đô',
          icon: '🍧',
          desc: 'Ly chè bột lọc bọc heo quay ướp đá độc đáo',
          costPrice: 8_000,
          sellPrice: 15_000,
        },
      ],
      description: 'Đậu phộng cay giòn cùng chè hẻm đậm đà giữ chân khách râm ran cả tối!',
    },
    {
      level: 4,
      title: 'Cà Phê Bệt Có Tiếng',
      cupsRequired: 120,
      unlockedItems: [
        {
          id: 'ca_phe_muoi',
          name: 'Cà Phê Muối Xứ Huế',
          icon: '🧂',
          desc: 'Vị mặn mà béo ngậy ủ lạnh đặc trưng miền Trung',
          costPrice: 8_500,
          sellPrice: 18_000,
        },
        {
          id: 'banh_ep_hue',
          name: 'Bánh Ép Huế Nóng Giòn',
          icon: '🫓',
          desc: 'Bánh ép mỡ hành thịt trứng giòn thơm đặc sản Huế đóng gói',
          costPrice: 8_000,
          sellPrice: 15_000,
        },
      ],
      description: 'Cà phê muối béo mặn kết hợp bánh ép nóng hổi, khách công sở xếp hàng nườm nượp!',
    },
    {
      level: 5,
      title: 'Tụ Điểm Hút Giới Trẻ',
      cupsRequired: 250,
      unlockedItems: [
        {
          id: 'tra_sam_dua',
          name: 'Trà Sâm Dứa Đà Nẵng',
          icon: '🍵',
          desc: 'Trà sâm dứa thơm lừng ngọt mát giải khát phố biển',
          costPrice: 4_000,
          sellPrice: 12_000,
        },
        {
          id: 'tre_tron',
          name: 'Tré Trộn Chợ Hàn',
          icon: '🌶️',
          desc: 'Tré gói rơm chua giòn bóc ăn ngay kèm ớt xiêm',
          costPrice: 14_000,
          sellPrice: 25_000,
        },
      ],
      description: 'Tré trộn cay xè cùng trà sâm dứa đã khát khiến giới trẻ ngồi kín cả góc phố!',
    },
    {
      level: 6,
      title: 'Đặc Sản Vỉa Hè Nổi Tiếng',
      cupsRequired: 500,
      unlockedItems: [
        {
          id: 'che_bot_loc',
          name: 'Chè Bột Lọc Heo Quay',
          icon: '🥣',
          desc: 'Vị ngọt mặn độc lạ trứ danh sông Hương',
          costPrice: 11_000,
          sellPrice: 20_000,
        },
        {
          id: 'sua_dau_nanh',
          name: 'Sữa Đậu Nành Nóng',
          icon: '🥛',
          desc: 'Ly sữa đậu béo ngậy ủ nóng ấm lòng đêm phố cổ',
          costPrice: 4_500,
          sellPrice: 10_000,
        },
      ],
      description: 'Món đặc sản độc lạ sông Hương đưa tên tuổi quán vang danh khắp vùng!',
    },
    {
      level: 7,
      title: 'Đại Bản Doanh Vỉa Hè',
      cupsRequired: 1000,
      unlockedItems: [
        {
          id: 'mi_quang',
          name: 'Mì Quảng Ếch Trộn',
          icon: '🍜',
          desc: 'Tô mì sợi to đậm đà đậu phộng bánh tráng ăn liền',
          costPrice: 16_000,
          sellPrice: 28_000,
        },
        {
          id: 'bia_la_rue',
          name: 'Bia Larue Kèm Cá Bò',
          icon: '🍺',
          desc: 'Bia con cọp phố biển nhậu lai rai cực bén',
          costPrice: 11_000,
          sellPrice: 18_000,
        },
      ],
      description: 'Mì Quảng đậm vị và bia Larue phố biển phục vụ thâu đêm suốt sáng!',
    },
    {
      level: 8,
      title: 'Huyền Thoại Vỉa Hè',
      cupsRequired: 2000,
      unlockedItems: [],
      description: 'Vang danh khắp dải đất miền Trung! Ông trùm ẩm thực đường phố!',
    },
  ],

  south: [
    {
      level: 1,
      title: 'Quầy Cóc Khởi Nghiệp',
      cupsRequired: 0,
      unlockedItems: [],
      description: 'Bàn ghế nhựa giản dị, bắt đầu sự nghiệp vỉa hè Sài Gòn sôi động.',
    },
    {
      level: 2,
      title: 'Quán Nước Quen Mặt',
      cupsRequired: 25,
      unlockedItems: [
        {
          id: 'nuoc_sam',
          name: 'Nước Sâm Mía Lau Rong Biển',
          icon: '🌿',
          desc: 'Chai nước sâm nấu lá mía lau ướp xô đá mát lạnh',
          costPrice: 4_500,
          sellPrice: 10_000,
        },
        {
          id: 'nuoc_mia_sau_rieng',
          name: 'Nước Mía Sầu Riêng',
          icon: '🎋',
          desc: 'Mía ngọt sầu riêng thơm nức mũi ép sẵn ướp lạnh',
          costPrice: 10_000,
          sellPrice: 18_000,
        },
      ],
      description: 'Nước sâm mía lau mát rượi và nước mía sầu riêng thơm lừng làm khách mê mẩn!',
    },
    {
      level: 3,
      title: 'Điểm Hẹn Buôn Chuyện',
      cupsRequired: 60,
      unlockedItems: [
        {
          id: 'banh_trang_nuong',
          name: 'Bánh Tráng Nướng Đà Lạt',
          icon: '🍕',
          desc: 'Pizza vỉa hè mỡ hành trứng cút thơm nức mũi đóng gói',
          costPrice: 10_000,
          sellPrice: 18_000,
        },
        {
          id: 'tra_dau',
          name: 'Trà Dâu Đông Du',
          icon: '🍓',
          desc: 'Trà đen chua ngọt dâu tây ngâm trào lưu giới trẻ',
          costPrice: 8_500,
          sellPrice: 18_000,
        },
      ],
      description: 'Bánh tráng nướng nóng hổi và trà dâu Đông Du níu chân giới trẻ ngồi kín bàn!',
    },
    {
      level: 4,
      title: 'Cà Phê Bệt Có Tiếng',
      cupsRequired: 120,
      unlockedItems: [
        {
          id: 'pha_lau',
          name: 'Phá Lấu Bò Kèm Bánh Mì',
          icon: '🥘',
          desc: 'Nước cốt dừa thơm béo chấm bánh mì nóng giòn',
          costPrice: 16_000,
          sellPrice: 28_000,
        },
        {
          id: 'ca_vien_chien',
          name: 'Cá Viên Chiên Nước Mắm',
          icon: '🍢',
          desc: 'Xiên que chiên vàng giòn sốt mắm tỏi ớt đưa miệng',
          costPrice: 12_000,
          sellPrice: 22_000,
        },
      ],
      description: 'Phá lấu béo ngậy kèm cá viên chiên nước mắm khiến khách văn phòng mê mệt!',
    },
    {
      level: 5,
      title: 'Tụ Điểm Hút Giới Trẻ',
      cupsRequired: 250,
      unlockedItems: [
        {
          id: 'cacao_dua_dam',
          name: 'Cacao Dừa Dầm Ly Đá',
          icon: '🥥',
          desc: 'Dừa nạo giòn sần sật thạch cacao béo mát ướp đá',
          costPrice: 11_000,
          sellPrice: 22_000,
        },
        {
          id: 'com_chay',
          name: 'Cơm Cháy Chà Bông Mỡ Hành',
          icon: '🍘',
          desc: 'Cơm cháy giòn rụm ngập chà bông và mỡ hành đóng gói',
          costPrice: 11_500,
          sellPrice: 22_000,
        },
      ],
      description: 'Cơm cháy chà bông mỡ hành cùng cacao dừa dầm hút khách xếp hàng check-in!',
    },
    {
      level: 6,
      title: 'Đặc Sản Vỉa Hè Nổi Tiếng',
      cupsRequired: 500,
      unlockedItems: [
        {
          id: 'kho_bo_den',
          name: 'Đĩa Gỏi Khô Bò Đen',
          icon: '🐮',
          desc: 'Bịch khô bò đen đu đủ giòn kèm giấm chua ngọt',
          costPrice: 9_500,
          sellPrice: 18_000,
        },
        {
          id: 'banh_trang_tron',
          name: 'Bánh Tráng Trộn Bệt',
          icon: '🥢',
          desc: 'Bịch bánh tráng trộn sẵn bò khô trứng cút tiện lợi',
          costPrice: 10_000,
          sellPrice: 18_000,
        },
      ],
      description: 'Bánh tráng trộn bệt và khô bò đen trứ danh, khách du lịch nườm nượp tìm đến!',
    },
    {
      level: 7,
      title: 'Đại Bản Doanh Vỉa Hè',
      cupsRequired: 1000,
      unlockedItems: [
        {
          id: 'bia_sai_gon',
          name: 'Bia Sài Gòn Lùn Ướp Lạnh',
          icon: '🍺',
          desc: 'Bia lùn mát lạnh nâng ly cùng anh em chiến hữu',
          costPrice: 11_500,
          sellPrice: 20_000,
        },
      ],
      description: 'Bia Sài Gòn lùn ướp lạnh thâu đêm suốt sáng, không khí phố đêm rực lửa!',
    },
    {
      level: 8,
      title: 'Huyền Thoại Vỉa Hè',
      cupsRequired: 2000,
      unlockedItems: [],
      description: 'Thống lĩnh toàn bộ vỉa hè Sài Gòn hoa lệ! Ông trùm kinh doanh đường phố!',
    },
  ],
};

export const SURVIVAL_PERKS: SurvivalPerkDef[] = [
  {
    id: 'perk-chess',
    day: 3,
    name: 'Bàn Cờ Tướng & Điếu Cày',
    icon: '♟️',
    desc: 'Các bác trung niên và cao niên ghé quán ngồi chơi cờ rôm rả.',
    benefit: 'Khách ngồi lai rai lâu hơn, tăng 20% lượng khách ghé quán',
  },
  {
    id: 'perk-wifi',
    day: 5,
    name: 'Cục Phát Wifi Chùa',
    icon: '📶',
    desc: 'Sóng căng đét, sinh viên và dân công sở ghé quán ngồi làm việc.',
    benefit: 'Tăng 25% lượng khách vào ca trưa và chiều',
  },
  {
    id: 'perk-scout',
    day: 7,
    name: 'Chú Xe Ôm Đầu Ngõ',
    icon: '🛵',
    desc: 'Mạng lưới tai mắt thân thiết cảnh báo đội trật tự đô thị từ xa.',
    benefit: 'Cảnh báo sớm và giảm 30% tần suất kiểm tra đột xuất',
  },
  {
    id: 'perk-mist',
    day: 10,
    name: 'Hệ Thống Phun Sương & Bạt Cuốn',
    icon: '💨',
    desc: 'Hơi sương mát lạnh phủ quanh quán, ngồi hè phố vẫn dịu mát như máy lạnh.',
    benefit: 'Miễn nhiễm giảm khách khi thời tiết nắng gắt (hot)',
  },
  {
    id: 'perk-wholesale',
    day: 14,
    name: 'Mối Ruột Chợ Đầu Mối',
    icon: '📦',
    desc: 'Ký được hợp đồng mối sỉ chợ hoa quả Long Biên / Thủ Đức.',
    benefit: 'Giảm 20% giá vốn nguyên liệu toàn bộ món ăn',
  },
  {
    id: 'perk-speaker',
    day: 21,
    name: 'Dàn Loa Kẹo Kéo Lofi',
    icon: '📻',
    desc: 'List nhạc Trịnh & Lofi chill phố phường cực cuốn hút khách về đêm.',
    benefit: 'Tăng 50% lượng khách ghé quán vào ca tối (evening)',
  },
  {
    id: 'perk-license',
    day: 30,
    name: 'Giấy Khen & Giấy Phép Tạm',
    icon: '📜',
    desc: 'Được phường chứng nhận vỉa hè kiểu mẫu, xanh - sạch - đẹp.',
    benefit: 'Giảm 80% rủi ro trật tự đô thị và phạt vi phạm',
  },
];

export function getStallLevels(region: RegionKey = 'north'): StallLevelDef[] {
  return REGIONAL_STALL_LEVELS[region] ?? REGIONAL_STALL_LEVELS.north;
}

export const STALL_LEVELS: StallLevelDef[] = getStallLevels('north');

export function getLevelConfig(level: number, region: RegionKey = 'north'): StallLevelDef {
  const levels = getStallLevels(region);
  return levels.find((l) => l.level === level) ?? levels[0]!;
}

export function checkNextLevel(
  currentSales: number,
  currentLevel: number,
  region: RegionKey = 'north'
): StallLevelDef | null {
  const levels = getStallLevels(region);
  const next = levels.find((l) => l.level === currentLevel + 1);
  if (next && currentSales >= next.cupsRequired) {
    return next;
  }
  return null;
}

export function getPerkForDay(day: number): SurvivalPerkDef | null {
  return SURVIVAL_PERKS.find((p) => p.day === day) ?? null;
}
